import { render, staticRenderFns } from "./WorklistStart.vue?vue&type=template&id=10d09228"
import script from "./WorklistStart.vue?vue&type=script&lang=js"
export * from "./WorklistStart.vue?vue&type=script&lang=js"
import style0 from "./WorklistStart.vue?vue&type=style&index=0&id=10d09228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports